import { useSnackbars } from '@customerio/pluma-components/react';

import { type Asset } from '@/services/db/asset/entity';
import { copyToClipboard } from '@/hooks/user-actions/use-copy-to-clipboard';

import { useAssetOptimizerModal } from '../../optimizer';

export function useAssetActions({ onDelete }: { onDelete?: (asset: Asset) => void }) {
  const { show } = useAssetOptimizerModal();
  const snackbars = useSnackbars();

  const handleCopyUrl = async (asset: Asset, event: React.MouseEvent) => {
    event.stopPropagation();
    const success = await copyToClipboard(asset.path);
    if (success) {
      snackbars.create({
        variant: 'success',
        message: 'URL copied to clipboard',
      });
    } else {
      snackbars.create({
        variant: 'error',
        message: 'Failed to copy URL to clipboard',
      });
    }
  };

  const handleDelete = (asset: Asset, event: React.MouseEvent) => {
    event.stopPropagation();
    if (onDelete != null) {
      onDelete(asset);
    }
  };

  const handleOptimize = (asset: Asset, event: React.MouseEvent) => {
    event.stopPropagation();
    show({ originalAsset: asset });
  };

  return { handleCopyUrl, handleDelete, handleOptimize };
}
